import { createService } from '@bonanza-social/toolkit/api';
import {
  GetLaunchUrlRequestSchema,
  GetLaunchUrlResponseSchema,
  GetRewardsResponseSchema,
} from './MetaGamesService.schemas';

export default createService(
  {
    getCount: {
      method: 'GET',
      url: '/metagame/rewards',
      responseSchema: GetRewardsResponseSchema,
    },
    getLaunchUrl: {
      method: 'POST',
      url: '/metagame/launch',
      headers: {
        'X-Feature-Enable-Token-Rewards': true,
      },
      requestSchema: GetLaunchUrlRequestSchema,
      responseSchema: GetLaunchUrlResponseSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
